import {
  ApplicationRef,
  Component,
  ElementRef,
  Injector,
  NgZone,
  ViewEncapsulation,
} from "@angular/core";

import { BfxTradeBlotterComponent } from "./bfx-trade-blotter.component";
import { BfxTradeBlotterService } from "./services/bfx-trade-blotter.service";
import { GoldenLayoutService } from "../golden-layout/golden-layout-service";
import { TranslateService } from "@ngx-translate/core";
import { BfxTradeContextMenuService } from "./services/bfx-trade-contextmenu.service";
import { TradeTableDefinitionFactory } from "shared/cubiq-services";
import { SystemConfigPromiseService, ProfilePromiseActionService } from "shared/cubiq-services";
import { BfxBlotterFilterService } from "../bfx-blotter-filter/bfx-blotter-filter.service";
import { BfxBaseBlotterColumnSelectorService } from "../bfx-base-blotter/bfx-base-blotter-columnselector.service";
import { BfxBlotterTradeFilterService } from "../bfx-blotter-trade/services/bfx-blotter-trade-filter.service";
import { BfxMouseModifierKeyService } from "app/bfx-common/services/bfx-mouse-modifier-key.service";
import { BfxUserProfileService } from "../bfx-common/services/bfx-user-profile.service";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { BfxSaveProfileNotificationService } from "../bfx-common/services/bfx-save-profile-notification.service";
import { BfxVwapTradeService } from "app/bfx-vwap/bfx-vwap-trade.service";
import { BfxVwapInfo } from "app/bfx-vwap/bfx-vwap-info";
import { BfxTradeDetailsContextMenuService } from "./services/bfx-trade-blotter-details-contextmenu.service";

@Component({
  selector: "bfx-order-details-trade-blotter",
  // old styling (not refactored)
  templateUrl: "./html/bfx-ladder-blotter-trade.html",
  // half refactored (some things are broken)
  // templateUrl: './html/bfx-ladder-blotter-trade.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class BfxTradeBlotterDetailsComponent extends BfxTradeBlotterComponent {
  constructor(
    BfxBlotterElement: ElementRef,
    applicationRef: ApplicationRef,
    injector: Injector,
    service: BfxTradeBlotterService,
    contextMenuService: BfxTradeContextMenuService,
    zone: NgZone,
    _tableDefinitionFactory: TradeTableDefinitionFactory,
    layoutService: GoldenLayoutService,
    translationService: TranslateService,
    blotterFilterService: BfxBlotterFilterService,
    filteringService: BfxBlotterTradeFilterService,
    columnSelectorService: BfxBaseBlotterColumnSelectorService,
    profileActionService: ProfilePromiseActionService,
    sysConfigService: SystemConfigPromiseService,
    mouseModifierKeyService: BfxMouseModifierKeyService,
    saveProfileNotificationService: BfxSaveProfileNotificationService,
    protected userProfileService: BfxUserProfileService,
    vwapTradeService: BfxVwapTradeService,
    protected vwapInfo: BfxVwapInfo,
    protected tradeDetailsContextMenuService: BfxTradeDetailsContextMenuService,
  ) {
    super(
      BfxBlotterElement,
      applicationRef,
      injector,
      service,
      contextMenuService,
      zone,
      _tableDefinitionFactory,
      layoutService,
      translationService,
      blotterFilterService,
      filteringService,
      columnSelectorService,
      profileActionService,
      sysConfigService,
      mouseModifierKeyService,
      saveProfileNotificationService,
      userProfileService,
      vwapTradeService,
      vwapInfo,
    );
    this.orderDetails = true;
    this.embeddedTableMode = true;
    this.embeddedTableModeContextMenu = true;
    this.embeddedContextMenuService = tradeDetailsContextMenuService;
    this.embeddedTableModeSuppressSelection = false;
  }
}
